import React from 'react';
import { motion } from 'framer-motion';
import {
  Users, BookOpen, Eye, CreditCard, TrendingUp,
  Crown, Clock, Trash2, Shield, ShieldOff, BarChart3,
  Link2, Percent, Euro, Plus, Copy, Check as CheckIcon, X,
  Ban, UserCheck, Gift, CalendarPlus, Download, History, MoreVertical, Mail, Send, Tag
} from 'lucide-react';
import { Button } from '../../ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import { TabsContent } from '../../ui/tabs';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from '../../ui/dropdown-menu';

export const PendingTab = ({ ctx }) => {
  const { pendingStories, handleApproveStory, handleRejectStory } = ctx;
  return (
  <TabsContent value="pending" className="space-y-4">
              {pendingStories.length === 0 ? (
                <Card className="border-0 shadow-sm">
                  <CardContent className="py-12 text-center">
                    <p className="text-muted-foreground">Geen verhalen wachtend op goedkeuring</p>
                  </CardContent>
                </Card>
              ) : (
                pendingStories.map(story => (
                  <Card key={story.id} className="border-0 shadow-sm overflow-hidden">
                    <div className="flex flex-col md:flex-row">
                      {story.cover_image_url && (
                        <div 
                          className="w-full md:w-40 h-32 md:h-auto bg-cover bg-center"
                          style={{ backgroundImage: `url(${story.cover_image_url})` }}
                        />
                      )}
                      <CardContent className="flex-1 p-6">
                        <div className="flex items-start justify-between">
                          <div>
                            <h3 className="font-semibold text-lg">{story.title}</h3>
                            <p className="text-sm text-muted-foreground">door {story.grandma_name}</p>
                            <p className="text-sm text-muted-foreground mt-2 line-clamp-2">{story.description}</p>
                            <p className="text-xs text-muted-foreground mt-2">{story.pages?.length || 0} pagina's</p>
                          </div>
                          <div className="flex gap-2">
                            <Button
                              size="sm"
                              onClick={() => handleApproveStory(story.id)}
                              className="bg-green-600 hover:bg-green-700 text-white"
                            >
                              Goedkeuren
                            </Button>
                            <Button
                              size="sm"
                              variant="destructive"
                              onClick={() => handleRejectStory(story.id)}
                            >
                              Afwijzen
                            </Button>
                          </div>
                        </div>
                      </CardContent>
                    </div>
                  </Card>
                ))
              )}
            </TabsContent>
  );
};
